const cookieBannerLibraries = ['cookieyes', 'custom'];

// Create an event system
const CookieConcentManager = function () {
  this.events = {};
};

// Add an event listener
CookieConcentManager.prototype.on = function ( event, listener ) {
  if ( typeof this.events[event] !== 'object' ) {
    this.events[event] = [];
  }
  this.events[event].push( listener );
};

// Fire an event
CookieConcentManager.prototype.emit = function ( event, ...args ) {
  if ( typeof this.events[event] === 'object' ) {
    this.events[event].forEach( listener => listener.apply( this, args ) );
  }
};

// Create an instance of the event system
let cookieConcentManager = new CookieConcentManager();

const getCookieValue = ( libraryName ) => {
  if ( libraryName === 'cookieyes' ) {
    const cookieName = 'cookieyes-consent';
    // Get all cookies
    const allCookies = document.cookie;
    // Split cookies into an array
    const cookieArray = allCookies.split( ';' );
    // Iterate over each cookie
    for ( const cookie of cookieArray ) {
      const trimmedCookie = cookie.trim();

      // If this cookie string starts with the name we want
      if ( trimmedCookie.startsWith( `${cookieName}=` ) ) {
        return decodeURIComponent( trimmedCookie.substring( cookieName.length + 1 ) );
      }
    }
  }
  // Return null if the cookie wasn't found
  return null;
};

const checkConsent = ( libraryName, cookieValue ) => {
  if ( libraryName === 'cookieyes' ) {
    if ( !cookieValue ) {
      return false;
    }
    // Split the cookie value by comma
    const cookieParts = cookieValue.split( ',' );
    // Iterate over each part
    for ( const part of cookieParts ) {
      // Split each part by colon to get key-value pairs
      const [key, value] = part.split( ':' );
      // Check if the key is 'consent' and if the value is 'yes'
      if ( key === 'consent' && value === 'yes' ) {
        return true;
      }
    }
  }
  // If 'consent:yes' is not found, return false
  return false;
};

const renderIframe = () => {
  const iframes = document.querySelectorAll( 'iframe[data-src]' );
  const consentPlaceholders = document.querySelectorAll( '.b3rg-cookie-consent-placeholder' );
  for ( let iframe of iframes ) {
    iframe.src = iframe.getAttribute( 'data-src' );
  }
  for ( let placeholder of consentPlaceholders ) {
    placeholder.remove();
  }
};

const checkAndRender = ( libraryName ) => {
  const cookieValue = getCookieValue( libraryName );
  const cookieConsentGranted = checkConsent( libraryName, cookieValue );
  if ( cookieConsentGranted ) {
    renderIframe();
  }
};

// Add an event listener
cookieConcentManager.on( 'accept', () => {
  const libraryName = cookieBannerLibraries[0];//NOSONAR TODO: Library names should be passed dynamically via filters
  checkAndRender( libraryName );
} );

document.addEventListener( 'DOMContentLoaded', () => {
  const libraryName = cookieBannerLibraries[0];
  checkAndRender( libraryName );

  const customButtons = document.querySelectorAll(
    '.b3rg-cookie-consent-placeholder__review'
  );
  customButtons.forEach( ( customButton ) => {
    customButton.addEventListener( 'click', () => {
      const revisitButton = document.querySelector( '.cky-btn-customize' );
      revisitButton.click();
    } );
  } );

  const acceptButtons = document.querySelectorAll(
    '.cky-btn-accept'
  );

  acceptButtons.forEach( ( acceptButton ) => {
    acceptButton.addEventListener( 'click', () => {
      cookieConcentManager.emit( 'accept' );
    } );
  } );
} );
